import React, { useState } from 'react'
import "./Experience.scss"
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import educationData from './educationData';
import PropTypes from 'prop-types';
import { motion } from "framer-motion";


export const Experience = () => {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  const Arrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none" }}
        onClick={onClick}
      />
    );
  }

  Arrow.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func
  };

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <Arrow />,
    prevArrow: <Arrow />
  };

  return (
    <div className='experience container'>
      <motion.div
        initial={{ y: '100%', opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="tabs-container">
          <p className='title'>My</p>
          <a className={activeTab === 1 ? 'active' : ''} onClick={() => handleTabClick(1)}>Experience</a>
          <a className={activeTab === 2 ? 'active' : ''} onClick={() => handleTabClick(2)}>Education</a>
      </motion.div>
      <div className="content-container">
        {activeTab === 1 && (
          <motion.div
            initial={{ y: '100%', opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="work-experience">
              <div className="title-container">
                <h2 className='title'>Software Engineer</h2>
                <h2 className='place'>at GlobalLogic</h2>
              </div>
              <h3 className='date'>October 2020 - Present</h3>
              <ul className='description-container'>
                <li>Developing an IAM Accelerator project, which helps administrators to set up and configure Identity and Access Management for AWS/Okta/Azure platforms simultaneously.</li>
                <li>Participating in code reviews and provided feedback to team members to ensure high-quality and maintainable code.</li>
                <li> Contributing to the development of user-friendly interfaces and provided support to end-users to ensure successful adoption of the IAM Accelerator.</li>
              </ul>
          </motion.div>
        )}
        {activeTab === 2 && (
            <Slider {...sliderSettings}>
            {educationData.map((slide, index) => {
              return (
                <motion.div
                  initial={{ y: '100%', opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.6, ease: 'easeOut' }}
                  className="education" key={index}>
                    <div className="title-container">
                      <h2 className='title'>{slide.title}</h2>
                      <h2 className='place'>{slide.place}</h2>
                    </div>
                    <h3 className='date'>{slide.date}</h3>
                    <ul className='description-container'>
                      <li>{slide.descriptionFirst}</li>
                      <li>{slide.descriptionSecond}</li>
                      <li>{slide.descriptionThird}</li>
                    </ul>
                </motion.div>
              );
            })}
          </Slider>
        )}
      </div>
    </div>
  )
}